function createStylesHelper(vault) {
  return {
    applyStyles(resource, scope, styles) {
      const id = typeof resource === "string" ? resource : resource.id;
      return vault.setMetaValue([id, "styles", scope], styles);
    },
    getAppliedStyles(resource) {
      const id = typeof resource === "string" ? resource : resource.id;
      return vault.getResourceMeta(id, "styles");
    }
  };
}
export { createStylesHelper };
//# sourceMappingURL=styles.mjs.map
